module.exports = __webpack_public_path__ + "static/media/14UNEP27.472735c6.jpg";